<template>
  <div class="message-box">
    <b-modal ref="modal-window" :title="message" size="xl modal-fullscreen-xxl-down" modal-class="message-box-modal">
      <template #modal-body>
        <div v-if="data && (data.isBlocked == 0 || data.isBlocked == null)" class="modal-body">
          <Textarea
            v-model="data.blockedInfo"
            placeholder=""
            :autoFocus="true"
            :label="$t('debtors.blockedText')"
            :rows="5"
          />
        </div>
      </template>

      <template #modal-footer>
        <span class="btn btn-secondary" @click="close()">{{ $t('general.cancel') }}</span>
        <span class="btn btn-primary" @click="confirm()">{{ $t('general.ok') }}</span>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import Textarea from "@/components/common/Textarea.vue";
  export default {
    name: 'ModalMessageDebtor',

    components: {
      Textarea
    },

    data () {
      return {
        data: null,
        blockedInfo: null,
        title: '',
        message: ''
      }
    },

    methods: {
      show (data, message) {
        this.data = data;
        this.message = message;
        this.$refs['modal-window'].show();
      },

      confirm () {
        this.$emit('confirm', this.data);
        this.$refs['modal-window'].hide();
      },

      close () {
        this.$refs['modal-window'].hide();
      }
    }
  }
</script>